import { Block, Text } from 'slate';
import { List } from 'immutable';
import detectNewline from 'detect-newline';
import BlockTypes from '../../../types/BlockTypes';
var DEFAULT_NEWLINE = '\n';
/**
 * Deserialize a text into a code block
 */

function deserializeCode(text, language) {
  var sep = detectNewline(text) || DEFAULT_NEWLINE;
  var lines = List(text.split(sep)).map(function (line) {
    return Block.create({
      type: BlockTypes.CODE,
      nodes: [Text.create(line)],
      data: {
        language: language
      }
    });
  });
  var code = Block.create({
    type: BlockTypes.CODES,
    nodes: lines
  });
  return code;
}

export default deserializeCode;